import { observer } from "mobx-react";
import { Box } from "@/components-v2/Box";
import { Logo } from "@/components-v2/Logo";
import { TitleText } from "@/common/landingPageComponents";
import { LanguageSelector } from "@/components-v2/LanguageSelector";
import { ThemeToggleButton } from "@/components-v2/AppBar";
import { applicationFrontPageUrl } from "@/utils/navigation";

export const LoginAppBar = observer(function LoginAppBar() {
  return (
    <Box bg padding gap={"lg"} justifyContent="space-between" alignItems="center">
      <Box alignItems="center" gap={"md"}>
        <Logo linkUrl={applicationFrontPageUrl()} />
        <TitleText
          title={{ key: "common.dcompany" }}
          subtitle={{ key: "login.context.subtitle" }}
        />
      </Box>
      <Box alignItems="center">
        <ThemeToggleButton />
        <LanguageSelector dropdownOptions={{ alignment: "end" }} />
      </Box>
    </Box>
  );
});
